export const REMINDER_WEEKDAYS = [1, 2, 3, 4, 5, 6, 7] as const;

/** ISO weekday: Monday = 1, Sunday = 7. */
export type ReminderWeekday = (typeof REMINDER_WEEKDAYS)[number];
